import { Component } from "@angular/core";

@Component({
  selector: "app-teams-content",
  templateUrl: "teams-content.component.html",
})
export class TeamsContentComponent {}
